import { AudioPlayer } from '@/client/audio-player/audio-player';
import { TrackDetails } from '@/common/model';
import { create } from 'zustand';

interface AudioPlayerState {
  track: TrackDetails | null;
  setTrack: (track: TrackDetails | null) => void;
  player: AudioPlayer;
}

export const useAudioPlayerStore = create<AudioPlayerState>((set) => ({
  track: null,
  setTrack: (track: TrackDetails | null) => set({ track }),
  player: new AudioPlayer(),
}));

export default useAudioPlayerStore;
